import React, { useEffect, useState, useRef } from "react";
import call from "../Assets/Chat/material-symbols_call.svg";
import imageupload from "../Assets/Chat/imageupload.svg";
import send from "../Assets/Chat/send.svg";
import profile1 from "../Assets/Chat/747a5d6b0e52325c2669d80bf100b210469b2a50.jpg";
import "../Style/Component/Specificchat.css";
import { getWithTokenAPI, postWithTokenAPI } from "../Util/Api.js";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { MdChatBubbleOutline } from "react-icons/md";
import { useLoaderData, useLocation } from "react-router-dom";
import folderAdd from "../Assets/Splash/edit.svg";

const Specificchat = ({ user }) => {
  const [msglist, setMsgList] = useState([]);
  console.log(msglist, "MSGLIST");
  const [message, setMessage] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const { state } = useLocation();
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const adminId = auth.userId;
  const permission = useSelector((state) => state?.auth?.permission);

  console.log(user, "USRE");
  // useEffect(() => {
  //   const fetchChatInboxCreate = async () => {
  //     try {
  //       const response = await getWithTokenAPI(
  //         token,
  //         `/messages/chat?user1=${adminId}&user2=${user.user_id}`,
  //       );
  //       alert("in");
  //       console.log("APIRESP", response);
  //       setMsgList(response?.data);
  //     } catch (error) {
  //       console.error("Fetch chat failed", error);
  //     }
  //   };
  //   fetchChatInboxCreate();
  // }, [token, adminId]);

  const bottomRef = useRef(null);
  const hasChat = msglist && msglist?.length > 0;

  let effectiveRole = "";
  let bgColor = "#3D42DF";
  let roleLabel = "Customer";
  if (hasChat) {
    const isAdminReceiver = msglist[0]?.receiver_roleType === "admin";

    effectiveRole = isAdminReceiver
      ? msglist[0]?.sender_roleType
      : msglist[0]?.receiver_roleType;

    bgColor = effectiveRole === "user" ? "#9F0000" : "#3D42DF";
    roleLabel = effectiveRole === "driver" ? "Driver" : "Customer";
  }

  /* ---------------- FETCH CHAT ---------------- */

  const fetchChatInbox = async () => {
    try {
      const response = await getWithTokenAPI(
        token,
        `/messages/chat?user1=${adminId}&user2=${user.user_id}`,
      );

      if (response) {
        setMsgList(response);
      }
    } catch (error) {
      console.error("Fetch chat failed", error);
    }
  };
  useEffect(() => {
    if (!user?.user_id) return;
    fetchChatInbox();
  }, [token, adminId, user?.user_id]);

  /* ---------------- AUTO SCROLL ---------------- */
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msglist]);

  /* ---------------- IMAGE UPLOAD ---------------- */
  const handleImagePick = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);

    try {
      const formData = new FormData();
      formData.append("files", file);

      const res = await postWithTokenAPI(
        token,
        `/upload_image?userId=${adminId}&type=admin`,
        formData,
      );

      const uploadedUrl = res?.data?.[0]?.fileUrl;
      if (uploadedUrl) setImageUrl(uploadedUrl);
    } catch {
      toast.error("Image upload failed");
    }
  };

  /* ---------------- SEND MESSAGE ---------------- */
  const handleSendMsg = async () => {
    if (!message && !imageUrl) return;

    try {
      const payload = {
        sender_id: adminId,
        sender_name: "admin",
        receiver_id: user?.user_id,
        receiver_name: user?.user_name,

        content: message || "",
        images: imageUrl ? [imageUrl] : [],
        documents: file ? [file.name] : [],
        audio: [],
      };

      const res = await postWithTokenAPI(token, "/messages", payload);

      if (res?.statusCode == "201") {
        // setMsgList((prev) => [...prev, res.data]);
        setMessage("");
        setImageFile(null);
        setImageUrl("");
        setFile(null);
        fetchChatInbox();
      }
    } catch (err) {
      console.error("Message send failed", err);
      toast.error("Message sending failed");
    }
  };

  /* ---------------- FORMATTERS ---------------- */
  const formatDate = (iso) =>
    new Date(iso).toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });

  const formatTime = (iso) =>
    new Date(iso).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  return (
    <div className="specificchat">
      {/* HEADER */}
      <div className="specificchatheader">
        {msglist?.length !== 0 ? (
          <>
            <div>
              <div className="avatar-wrapper">
                {msglist?.[0]?.sender_image ? (
                  <img
                    src={msglist?.[0]?.sender_image}
                    alt="profile"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                    onError={(e) => (e.target.style.display = "none")}
                  />
                ) : (
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#4f46e5",
                      color: "#fff",
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    {msglist?.[0]?.sender_name?.[0]?.toUpperCase()}
                    {msglist?.[0]?.sender_name?.slice(-1).toUpperCase()}
                  </div>
                )}
              </div>
              <span className="namespan">{msglist?.[0]?.sender_name}</span>
              <span
                className="typespan"
                style={{
                  background: bgColor,
                  border:
                    msglist?.[0]?.roleType !== "driver"
                      ? "1px solid white"
                      : "none",
                  marginLeft: "5px",
                }}
              >
                {msglist?.[0]?.sender_roletype}
              </span>
              {/* <span className="timespan">Response Time: 1 hour</span> */}
            </div>
            <img
              src={call}
              alt="call"
              onClick={() => {
                const m = msglist?.[0];
                if (!m) return;

                window.location.href = `tel:${
                  m.receiver?.roletype === "admin" ||
                  m.receiver?.roletype === "superadmin"
                    ? m.sender_phoneNumber
                    : m.receiver?.phoneNumber
                }`;
              }}
            />
          </>
        ) : (
          <span
            style={{
              width: "100%",
              color: "white",
              fontSize: "larger",
              fontWeight: "450",
              textAlign: "center",
            }}
          >
            Garb it Admin Chat Box
          </span>
        )}
      </div>

      {/* BODY */}
      <div className="specificchatbody">
        <div className="chats">
          {msglist && msglist?.length > 0 ? (
            msglist.map((item, index) => {
              if (!item || item?.content === null) return null;
              return (
                <React.Fragment key={index}>
                  <div className="chatstime">
                    <span>{formatDate(item?.createdAt)}</span>
                  </div>

                  <div
                    className={`chatbyuser ${item?.sender_roletype === "admin" || item?.sender_roletype === "superadmin" ? "send" : ""}`}
                  >
                    {/* <img src={item?.sender_profileimage} alt="profile" /> */}
                    <div className="avatar-wrapper">
                      {item?.sender_profileimage ? (
                        <img
                          src={item?.sender_profileimage}
                          alt="profile"
                          className="chat-avatar"
                        />
                      ) : (
                        <div className="chat-avatar-fallback">
                          {item?.sender_name?.[0]?.toUpperCase()}
                          {item?.sender_name?.slice(-1).toUpperCase()}
                        </div>
                      )}
                    </div>

                    <div className="chatbyuserright">
                      <span
                        className={`chatbyusername ${item?.sender_roletype === "admin" || item?.sender_roletype === "superadmin" ? "send" : ""}`}
                      >
                        <div>
                          <span className="namespan">{item?.sender_name}</span>
                          <span className="timespan">
                            {formatTime(item?.createdAt)}
                          </span>
                        </div>
                      </span>

                      <div className="chatbyusercontent">
                        {item.images?.length > 0 && (
                          <div className="chat-images">
                            {item.images.map((img, i) => (
                              <img key={i} src={img} alt="chat" />
                            ))}
                          </div>
                        )}
                        {item?.audio?.length > 0 && (
                          <div className={`message-audio received`}>
                            <div className="audio-bubble">
                              {/* <div className="audio-icon">
                                {" "}
                                <Mic size={20} />
                              </div> */}
                              <audio controls className="audio-player">
                                <source
                                  src={item?.audio[0]}
                                  type="audio/webm"
                                />
                                Your browser does not support audio.
                              </audio>
                            </div>
                          </div>
                        )}
                        {item?.documents?.length > 0 && (
                          <a href={item?.documents?.[0]} target="blank"></a>
                        )}

                        {item?.content && <p>{item.content}</p>}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })
          ) : (
            <div
              className="empty-chat"
              style={{
                width: "98%",
                height: "98%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <MdChatBubbleOutline size={64} />
              <p>Select a chat to start messaging</p>
            </div>
          )}
          <div ref={bottomRef} />
        </div>

        {/* INPUT */}
        {msglist?.length > 0 && permission?.message?.create && (
          <div className="chatinput">
            <div>
              {file && (
                <div className="image-preview">
                  <p>{file.name}</p>
                  <span
                    className="remove-img"
                    onClick={() => {
                      setFile(null);
                    }}
                  >
                    ×
                  </span>
                </div>
              )}
              {imageFile && (
                <div className="image-preview">
                  <img src={URL.createObjectURL(imageFile)} alt="preview" />
                  <span
                    className="remove-img"
                    onClick={() => {
                      setImageFile(null);
                      setImageUrl("");
                    }}
                  >
                    ×
                  </span>
                </div>
              )}
            </div>
            <textarea
              placeholder="Type a message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={1}
              onInput={(e) => {
                e.target.style.height = "auto";
                e.target.style.height =
                  Math.min(e.target.scrollHeight, 120) + "px";
              }}
            />
            {/* <label title="File Upload" className="iupload">
              <img src={folderAdd} />
              <input
                type="file"
                hidden
                onChange={(e) => setFile(e.target.files[0])}
              />
            </label> */}
            <label title="Image Upload" className="iupload">
              <img src={imageupload} alt="upload" />
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImagePick}
              />
            </label>

            <div className="send-btn" onClick={handleSendMsg}>
              <img src={send} alt="send" />
              <span>Send</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Specificchat;
